module.exports = "/images/london-16.jpg";